import update from 'immutability-helper';
import { handleActions } from 'redux-actions';
import { PURGE } from 'redux-persist';

import { initialState } from './initialize';

const stepReducer = handleActions(
  new Map([
    [
      PURGE,
      state => {
        return update(state, {
          $set: initialState,
        });
      },
    ],
  ]),
  initialState,
);

export default stepReducer;
